export enum HorizontalAlignment {
	Left,
	Center,
	Right,
}
